export const iconFontAwesomeMapsBuilding = (
	<i className="fa-solid fa-building"></i>
);
